import Dinero from 'dinero.js';
import { FinancialSummary } from '../../../../../clients/quipli-service/financials/financials';
import { OrderProduct } from '../../../../../clients/quipli-service/order/order';
import { ProductInventoryUnit } from '../../../../../clients/quipli-service/product/product';
import { FuelCharge } from '../types/fuel-charge-types';

export const computeFuelCharge = (
  financialSummary: FinancialSummary | undefined,
  fuelCharges: FuelCharge[],
  currency: Dinero.Currency,
  op: OrderProduct,
  au: ProductInventoryUnit,
): string => {
  const dineroAmount = Dinero({
    amount:
      financialSummary?.lineItems
        .filter(
          (li) => li.type === 'Product' && li.id.includes('fuel') && li.productId === op.product.fuelChargeProductId,
        )
        .at(0)
        ?.unitPrice.multiply(fuelCharges.find((fc) => fc.unitId === au.id)?.amount || 0)
        .getAmount() ?? 0,
    currency,
  });

  return dineroAmount.toFormat();
};
